import { render } from "./SummaryLease.vue?vue&type=template&id=5f99f73b&ts=true"
import script from "./SummaryLease.vue?vue&type=script&lang=ts"
export * from "./SummaryLease.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__